// Defines interfaces or React PropType shapes for frequently used Models.
import PropTypes from 'prop-types';
import { Folder } from '../enums/Folder';
import { Recipient } from 'types/conversation/recipient';

export const MessageShape = {
    sid: PropTypes.string.isRequired,
    attributes: PropTypes.object,
    body: PropTypes.string,
    channelSid: PropTypes.string,
    createdTimestamp: PropTypes.number.isRequired,
    updatedTimestamp: PropTypes.number,
    senderIdentity: PropTypes.string,
    senderSid: PropTypes.string,
};

export interface ChannelAttributes {
    advertiser: string;
    advertiserKey?: string; // Should be present for IMS
    jobConfirmedFraudulent: boolean;
    isPreApplyConversation?: boolean;
    applyTime?: number;
    jobKey?: string;
    jobTitle: string;
    jobUrl: string;
    contactSourceApp: string;
}

export interface Conversationlock {
    primary: boolean;
    reason: string;
    timestamp: number;
}

export interface ChannelShape {
    channelSid: string;
    channelAttributes: ChannelAttributes;
    encryptedConvId: string;
    folder: Folder;
    friendlyName: string;
    lastMessageTimestamp: number;
    lastReadMessageTimestamp?: number;
    createdTimestampMs?: number;
    lastEventTimestamp: number;
    messages?: (typeof MessageShape)[];
    snippet: string;
    unreadMessagesCount: number;
    userSid: string;
    isTransient?: boolean;
    newlyPersisted?: boolean;
    classifications?: any;
    lastEventId?: any;
    lastEventType?: any;
    lastIsReminder?: boolean;
    lastReadMessageSid?: string;
    participants: any[];
    recipients: Recipient[];
    userAccountKey?: string;
    replyToEventId?: string;
    locks?: Conversationlock[];
}
